/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateTokenAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function CreateTokenAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateTokenAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 marginLeft="auto"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../CreateToken/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../CreateToken/Content'))}
 type="primary"
 size="normal"
 text="Add new personal access token"
/>
{children}
</React.Fragment>)
}